import { render, staticRenderFns } from "./OxygenPreview.vue?vue&type=template&id=651f5728&"
import script from "./OxygenPreview.vue?vue&type=script&lang=ts&"
export * from "./OxygenPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports